import { Reveal } from "../lib/motion";
import { SERVICES } from "../data";

export const Services = () => (
  <section id="services" className="relative py-28 md:py-36" data-testid="services-section">
    <div className="container-vx">
      <div className="mb-16 flex flex-col gap-6 md:mb-20 md:flex-row md:items-end md:justify-between">
        <div className="max-w-2xl">
          <Reveal>
            <span className="label-mono">/ Capabilities</span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-sans text-4xl font-light leading-tight tracking-tight md:text-5xl">
              A full-stack intelligence layer for the modern enterprise.
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.2} className="max-w-sm">
          <p className="font-body text-neutral-600">
            Six disciplines, one operating system. We compose them into systems
            that think, act and improve on their own.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 gap-4 md:gap-5 lg:grid-cols-12">
        {SERVICES.map((s, i) => {
          const Icon = s.icon;
          return (
            <Reveal key={s.title} delay={(i % 2) * 0.1} className={s.span}>
              <div
                className="group relative flex h-full flex-col justify-between overflow-hidden rounded-2xl border border-black/10 bg-white p-8 transition-all duration-500 hover:-translate-y-1 hover:border-black/25 hover:card-shadow md:p-10"
                data-testid={`service-card-${i}`}
              >
                <div className="pointer-events-none absolute -right-10 -top-10 h-40 w-40 rounded-full bg-[var(--accent)]/[0.08] blur-3xl opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                <div className="flex items-start justify-between">
                  <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl border border-black/10 bg-[#f4f4f1] text-black transition-colors duration-500 group-hover:border-[var(--accent)]/40 group-hover:text-[var(--accent)]">
                    <Icon className="h-5 w-5" strokeWidth={1.5} />
                  </div>
                  <span className="font-mono text-xs text-neutral-400">{s.tag}</span>
                </div>
                <div className="mt-16">
                  <h3 className="font-sans text-2xl font-medium tracking-tight">
                    {s.title}
                  </h3>
                  <p className="mt-3 max-w-md font-body text-neutral-600">
                    {s.desc}
                  </p>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
